import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/timesJinju-2023'
  },
  {
    path: '/metting-2023',
    component: () => import(/* webpackChunkName: "metting-2023" */ '../views/meeting/meeting-2023.vue'),
    meta: {
      title: '2023影响力 · 中国 时代峰会',
    }
  },
  {
    path: '/timesMarketing-2022',
    component: () => import(/* webpackChunkName: "forum-marketing-fifteen" */ '../views/marketing/forum-marketing-fifteen'),
    meta: {
      title: '第十五届时代营销盛典',
    }
  },
  {
    path: '/timesAirport-2023',
    component: () => import(/* webpackChunkName: "airport" */ '../views/airport/airport-fifth.vue'),
    meta: {
      title: '第五届（中国）广州商务航空展',
    }
  },
  {
    path: '/timesAirport-2022',
    redirect: '/timesAirport-2023'
  },
  {
    path: '/timesProperty-2021',
    component: () => import(/* webpackChunkName: "property" */ '../views/forum/forum-property-2021.vue'),
    meta: {
      title: '2021中国地产 时代百强论坛',
    }
  },
  {
    path: '/timesForum-2020',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-topics.vue'),
    meta: {
      title: '时代论坛专题',
    }
  }, {
    path: '/timesProperty-2020',
    component: () => import(/* webpackChunkName: "property" */ '../views/forum/forum-property.vue'),
    meta: {
      title: '2020中国地产 时代百强论坛',
    }
  }, {
    path: '/timesMarketing-2020',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-marketing.vue'),
    meta: {
      title: '第十三届时代营销盛典暨',
    }
  }, {
    path: '/timesXyBrand-2020',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-xy-brand.vue'),
    meta: {
      title: '兴·世家|承·未来 品牌发布会暨财富高端论坛',
    }
  }, {
    path: '/timesJinju-2020',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-jinju.vue'),
    meta: {
      title: '2020时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2020-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-jinju-detail.vue'),
    meta: {
      title: '第五届时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2021',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-jinju-2021.vue'),
    meta: {
      title: '2021时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2021-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-jinju-2021-detail.vue'),
    meta: {
      title: '第六届时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2022',
    component: () => import(/* webpackChunkName: "about" */ '../views/jinju/forum-jinju-2022.vue'),
    // component: () => import(/* webpackChunkName: "about" */ '../views/jinju/2022_backup.vue'),
    meta: {
      title: '2022时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2022-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/jinju/forum-jinju-2022-detail.vue'),
    meta: {
      title: '第七届时代金融金桔奖',
    }
  },
  {
    path: '/timesMeeting-2020',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-timesMeeting'),
    meta: {
      title: ' 2020时代峰会',
    }
  },
  {
    path: '/timesMarketing-2021',
    component: () => import(/* webpackChunkName: "about" */ '../views/forum/forum-marketing-fourteenth'),
    meta: {
      title: ' 第十四届时代营销盛典暨',
    }
  },
  {
    path: '/timesJinju-2023',
    component: () => import(/* webpackChunkName: "about" */ '../views/jinju/forum-jinju-2023.vue'),
    // component: () => import(/* webpackChunkName: "about" */ '../views/jinju/2022_backup.vue'),
    meta: {
      title: '2023时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2023-detail',
    component: () => import(/* webpackChunkName: "about" */ '../views/jinju/forum-jinju-2023-detail.vue'),
    meta: {
      title: '第七届时代金融金桔奖',
    }
  },{
    path: '/timesMarketing-2023',
    component: () => import(/* webpackChunkName: "about" */ '../views/marketing/forum-marketing-sixteen'),
    meta: {
      title: '第十六届时代营销盛典',
    }
  },{
    path: '/timesMarketing-2024',
    component: () => import(/* webpackChunkName: "timesMarketing-2024" */ '../views/marketing/forum-marketing-seventeen-new'),
    meta: {
      title: '第十七届时代营销盛典',
    }
  },{
    path: '/timesMarketing-2024-detail',
    component: () => import(/* webpackChunkName: "timesMarketing-2024" */ '../views/marketing/forum-marketing-seventeen-detail'),
    meta: {
      title: '第十七届时代营销盛典',
    }
  },{
    path: '/esg-2024',
    component: () => import(/* webpackChunkName: "esg" */ '../views/esg/esg-2024.vue'),
    meta: {
      title: 'ESG与高质量发展创新论坛',
    }
  },
  {
    path: '/metting-2024',
    component: () => import(/* webpackChunkName: "metting-2024" */ '../views/meeting/meeting-2024.vue'),
    meta: {
      title: '2024年影响力·时代 新质生产力赋能高质量发展论坛',
    }
  },
  {
    path: '/timesJinju-2024',
    component: () => import(/* webpackChunkName: "forum-jinju-2024" */ '../views/jinju/forum-jinju-2024'),
    meta: {
      title: '2024时代金融金桔奖',
    }
  },
  {
    path: '/timesJinju-2024-detail',
    component: () => import(/* webpackChunkName: "forum-jinju-2024-detail" */ '../views/jinju/forum-jinju-2024-detail'),
    meta: {
      title: '2024时代金融金桔奖-详情',

    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.afterEach(route => {
  if (route.meta.title) {
    document.title = route.meta.title
  }
})

export default router
